(function() {
'use strict';

angular.module('TR')
.directive('marhabaSearchUnit', function() {
    return {
        templateUrl: 'partials/searchunit/marhaba',
        controller: 'MarhabaSearchUnitCtrl',
        controllerAs: 'msu',
        replace: true,
        scope: {
            areaOverride: '@'
        },
        restrict: 'E',
        link() {
            // do nothing
        }
    };
});
})();
